import { render, staticRenderFns } from "./persons-or-places.vue?vue&type=template&id=49839033&"
import script from "./persons-or-places.vue?vue&type=script&lang=js&"
export * from "./persons-or-places.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports